module.exports = __webpack_public_path__ + "img/03@2x.e1994f4e.png";